import { EFormType, PublicationChannel, PublicationStatus, type SourcingEventDto } from "../../autogen/bff-api";

export const announcedOnDoffin = (event: SourcingEventDto): boolean =>
  event.eventContext.type === "Public" &&
  (event.eventContext.publications ?? []).some(
    (publication) =>
      publication.channel === PublicationChannel.Doffin &&
      publication.eFormType !== EFormType.Can29 &&
      publication.status === PublicationStatus.Published,
  );
